// 회원가입 / 탈퇴 신청 취소 등에서 공용으로 사용하는 약관(Terms.V2) 항목 정의.
// link가 window.location.origin에 의존하므로 SSR 안전을 위해 렌더 시점에 호출하는 팩토리로 제공한다.
export const getTermItemMap = () => ({
	USE: {
		name: 'USE',
		label: '이용약관',
		link: `${window.location.origin}/policy/terms`,
		target: '_self',
		isRequired: true,
	},
	CLEAN_ENCAR: {
		name: 'CLEAN_ENCAR',
		label: '클린엔카 규정에 대한 안내',
		link: `${window.location.origin}/policy/clean`,
		target: '_self',
		isRequired: true,
	},
	MARKETING_COLLECTION_INFORMATION: {
		name: 'MARKETING_COLLECTION_INFORMATION',
		label: '마케팅 목적의 개인정보 수집 및 이용',
		link: `${window.location.origin}/policy/marketing`,
		target: '_self',
		isRequired: false,
	},
	MARKETING_RECEIVE_INFORMATION: {
		name: 'MARKETING_RECEIVE_INFORMATION',
		label: '광고성 정보 수신',
		link: `${window.location.origin}/policy/marketing`,
		target: '_self',
		isRequired: false,
	},
	MARKETING_NONMEMBER: {
		name: 'MARKETING_NONMEMBER',
		label: '비회원 수집 데이터 활용',
		link: `${window.location.origin}/policy/marketing`,
		target: '_self',
		isRequired: false,
	},
	PERSONAL_AGE_LIMITATION: {
		name: 'PERSONAL_AGE_LIMITATION',
		label: '만 14세 이상입니다',
		target: '_self',
		isRequired: true,
	},
});

// 전달한 name 배열의 순서대로 약관 항목 배열을 반환한다.
export const getTermItems = (names) => {
	const map = getTermItemMap();
	return names.map((name) => map[name]);
};
